angular.module('impactx.deliverycomplaint').controller('ComplaintItemCtrl', ComplaintItemCtrl);

ComplaintItemCtrl.$inject = ['$scope', 'dataGen'];

function ComplaintItemCtrl($scope, dataGen) {
    
    // this is very ugly but i don't want to change PriceProperty - DTO
    var tmp = $scope.complaintItem.newPrice.totalNetValue;
    $scope.complaintItem.newPrice.totalNetValue = {
        value: tmp,
        label: '',
        readOnly: $scope.readOnly
    };
    if ($scope.complaintItem.marketplacePrice) {
        tmp = $scope.complaintItem.marketplacePrice.totalNetValue;
        $scope.complaintItem.marketplacePrice.totalNetValue = {
            value: tmp,
            label: '',
            readOnly: $scope.readOnly
        };
    }
    
    $scope.$watch(function(){
        return impactX.isDefined($scope, 'complaintItem.reason.selected');
    }, function(newVal, oldVal) {
        if(newVal && newVal.id && (!oldVal || oldVal && oldVal.id !== newVal.id)){
            handleReason(newVal);
        }
    });
    
    $scope.showInternalComments = function(){
        var com = $scope.complaintItem.comments.internalComments;
        return com && (com.comments.length>0 || $scope.showComments);
    };

    $scope.showExternalComments = function(){
        var com = $scope.complaintItem.comments.externalComments;
        return com && (com.comments.length>0 || (!$scope.readOnly && $scope.showComments));
    };
    
    $scope.canEditPrice = function(){
        if($scope.isClosed && !impactX.isDefined($scope, 'complaintItem.hasPriceDifference')) {
            return false;
        }
        var reason = impactX.isDefined($scope, 'complaintItem.reason.selected.id');
        var treatment = impactX.isDefined($scope, 'complaintItem.treatment.selected.id');
        var result = false;
        if(reason && treatment) {
            if(treatment === 1) { // treatment "accept"...
                result = [2, 3, 5].indexOf(reason) >= 0; // ...and reason either "over shipment", "replacement" or "not ordered"
            } else {
                result = treatment === 5; // treatment "price reduction"
            }
        }
        return result;
    };

    $scope.canEditControls = function(){
        if($scope.isClosed) {
            return false;
        }
        var reason = impactX.isDefined($scope, 'complaintItem.reason.selected.id');
        var treatment = impactX.isDefined($scope, 'complaintItem.treatment.selected.id');
        var result = false;
        if(reason && treatment && reason === 2 && treatment === 1) {
            result = true;
        }
        return result;
    };

    $scope.checkRequireCtrl = function (type) {
        let ctrlElem = $scope.complaintItem.control[type];
        if (ctrlElem) {
            return ctrlElem.showMust;
        }
        return false;
    };
    
    // item is a cpiDTO
    var handleReason = function(selected){
        if (selected) {
            var item = $scope.complaintItem;
            var temp = {};
            var params = {
                reasonId: selected.id,
                dniId: item.dniId
            };
            dataGen.getData(temp, params, '/deliverycomplaint/reason').then(function ()
            {
                if (temp && temp.data && temp.data.entries)
                {
                    var selectedTreatment = item.treatment.selected;
                    item.treatment.entries = temp.data.entries;
                    var itemEntries = item.treatment.entries;
                    var selectedIndex = findTreatment(selectedTreatment); // array.indexOf() does not work here, because we need to search in the new entries array
                    if(itemEntries.length === 1)
                    {
                        item.treatment.selected = itemEntries[0]; // if only one entry is possible, select it
                    }
                    else if(selectedIndex >= 0)
                    {
                        // if we find the last selected treatment in the new list, select it (could have other index)
                        item.treatment.selected = itemEntries[selectedIndex];
                    }
                    else
                    {
                        // else reset the selected treatment
                        delete item.treatment.selected;
                    }
                }
            })
        }
    };

    /**
     * pretty much the same as array.indexOf(), but this looks only for treatment.id
     * @param treatment the treatment entry to look for
     * @return {number} the index of treatment, -1 if not not found or treatment is falsy, or treatment.entries is falsy
     */
    var findTreatment = function(treatment)
    {
        if (treatment) {
            var entries = impactX.isDefined($scope, 'complaintItem.treatment.entries');
            if (entries) {
                for (var i = 0; i < entries.length; i++) {
                    if (entries[i].id === treatment.id) {
                        return i;
                    }
                }
            }
        }
        return -1;
    };

    $scope.selectComplaintItem = function(complaintItem, event) {
        if(event.target.tagName != "INPUT" && event.target.tagName != "BUTTON" && event.target.tagName != "TEXTAREA"
            && event.target.tagName != "MD-CHIPS-WRAP" && event.target.tagName != "MD-RADIO-BUTTON"
            && (event.target.parentNode == null || (event.target.parentNode.tagName != "BUTTON" && event.target.parentNode.tagName != "MD-RADIO-BUTTON"))
            && event.target.getAttribute("role") != "button") {
            if($scope.selected) {
                var index = $scope.selectedComplaintItems.indexOf(complaintItem);
                if(index > -1) {
                    $scope.selectedComplaintItems.splice(index, 1);
                }
            }
            else {
                $scope.selectedComplaintItems.push(complaintItem);
            }
            $scope.selected = !$scope.selected;
        }
    };
}
